<script setup>
import Card from '@/Components/Card/Card.vue';
import { inject } from 'vue';
import ACTION_TYPES from '@/Common/Enum/ActionType.js';
import ExplainScorePart from '@/Pages/DomainScore/Partials/DetailedReport/ExplainScorePart.vue';
import LinkDomainAnalysis from '@/Pages/DomainScore/Partials/DetailedReport/LinkDomainAnalysis.vue';
import DetailedReportHeader from '@/Pages/DomainScore/Partials/DetailedReport/DetailedReportHeader.vue';
import { getDkimDnsRecordStats } from '@/Common/DnsRecordMessaging.js';

const result = inject('score');
const dkimDnsRecordStatus = getDkimDnsRecordStats(result);
</script>

<template>
  <Card class="bg-white-opacity">
    <DetailedReportHeader
      title="DKIM"
      :description="
        $t(
          'domain_score.partials.detailed_report.impersonation.dkim_card.domainkey_identified'
        )
      "
      :tooltip="
        $t(
          'domain_score.partials.detailed_report.impersonation.dkim_card.dkim_record_stores'
        )
      "
    />
    <div class="mt-5 flex flex-col">
      <ExplainScorePart
        :title="
          $t(
            'domain_score.partials.detailed_report.impersonation.dkim_card.dns_record'
          )
        "
        :action-type="dkimDnsRecordStatus.actionType"
      >
        {{ dkimDnsRecordStatus.message }}
        <div v-if="dkimDnsRecordStatus.canAnalyse">
          &nbsp;-
          <LinkDomainAnalysis :domain="result.domain" fragment="spf" />
        </div>
      </ExplainScorePart>
      <ExplainScorePart
        v-if="result.impersonation.num_dkim_records"
        :title="
          $t(
            'domain_score.partials.detailed_report.impersonation.dkim_card.selectors'
          )
        "
        :action-type="ACTION_TYPES.INFO"
      >
        {{
          $t(
            'domain_score.partials.detailed_report.impersonation.dkim_card.selectors_found',
            { num: result.impersonation.num_dkim_records }
          )
        }}
      </ExplainScorePart>
    </div>
  </Card>
</template>
